/* KLIK v2 accessibility and Arabic helpers (package a11y-rtl). Loaded with defer from snippets/photoswipe-template.liquid.
   - window.KlikAr.count(n, forms): Arabic count phrase (1, 2, 3-10, 11+ and 100+ forms); Liquid twin: snippets/klik-ar-count.liquid
   - K-052: product thumbnails keep keyboard focus (theme.Slideshow childNavGoTo no longer blurs; Motion is not edited)
   - K-052 / K-136: the PhotoSwipe lightbox is a named modal dialog, keeps Tab inside, and gives focus back to its opener
     (or, after browsing, to the zoom button of the photo now shown); in Arabic the lightbox runs right to left like the
     page gallery (photos handed over in reverse order; arrows named "next photo" / "previous photo" by position)
   - K-121: links that open a new tab say so to screen readers; the bag link says how many items it holds
   No page-wide MutationObserver: two observers watch one element each (the lightbox class, the bag count). */
(function () {
  'use strict';
  var doc = document;
  var root = doc.documentElement;
  var isAr = function () { return /^ar/i.test(root.lang || ''); };

  /* ---------------- Arabic counts ---------------- */
  // one / two / few (3-10) / many (11-99, accusative singular) / hundred (100+ ending in 00-02: genitive singular)
  var FORMS = {
    piece: { one: 'قطعة واحدة', two: 'قطعتان', few: 'قطع', many: 'قطعة', zero: 'لا توجد قطع', en: ['piece', 'pieces'] },
    design: { one: 'تصميم واحد', two: 'تصميمان', few: 'تصاميم', many: 'تصميمًا', zero: 'لا توجد تصاميم', en: ['design', 'designs'] },
    product: { one: 'منتج واحد', two: 'منتجان', few: 'منتجات', many: 'منتجًا', zero: 'لا توجد منتجات', en: ['product', 'products'] },
    item: { one: 'منتج واحد', two: 'منتجان', few: 'منتجات', many: 'منتجًا', zero: 'فارغة', en: ['item', 'items'] },
    option: { one: 'خيار واحد', two: 'خياران', few: 'خيارات', many: 'خيارًا', zero: 'لا توجد خيارات', en: ['option', 'options'] },
    result: { one: 'نتيجة واحدة', two: 'نتيجتان', few: 'نتائج', many: 'نتيجة', zero: 'لا توجد نتائج', en: ['result', 'results'] },
    fabric: { one: 'قماش واحد', two: 'قماشان', few: 'أقمشة', many: 'قماشًا', en: ['fabric', 'fabrics'] },
    seat: { one: 'مقعد واحد', two: 'مقعدان', few: 'مقاعد', many: 'مقعدًا', en: ['seat', 'seats'] },
    chair: { one: 'كرسي واحد', two: 'كرسيان', few: 'كراسي', many: 'كرسيًا', en: ['chair', 'chairs'] },
    photo: { one: 'صورة واحدة', two: 'صورتان', few: 'صور', many: 'صورة', en: ['photo', 'photos'] },
    review: { one: 'تقييم واحد', two: 'تقييمان', few: 'تقييمات', many: 'تقييمًا', en: ['review', 'reviews'] },
    showroom: { one: 'معرض واحد', two: 'معرضان', few: 'معارض', many: 'معرضًا', en: ['showroom', 'showrooms'] },
    business_day: { one: 'يوم عمل واحد', two: 'يوما عمل', few: 'أيام عمل', many: 'يوم عمل', en: ['business day', 'business days'] },
    day: { one: 'يوم واحد', two: 'يومان', few: 'أيام', many: 'يومًا', en: ['day', 'days'] },
    hour: { one: 'ساعة واحدة', two: 'ساعتان', few: 'ساعات', many: 'ساعة', en: ['hour', 'hours'] },
    year: { one: 'سنة واحدة', two: 'سنتان', few: 'سنوات', many: 'سنة', en: ['year', 'years'] }
  };
  function group(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function genitive(w) { return String(w).replace(/ًا$/, '').replace(/اً$/, ''); }
  // KlikAr.count(5, 'piece') → «5 قطع»; KlikAr.count(n, {one, two, few, many, zero?, hundred?}); options.lang 'en' uses forms.en
  function count(n, forms, options) {
    var f = typeof forms === 'string' ? FORMS[forms] : forms;
    n = Math.floor(Math.abs(Number(n) || 0));
    if (!f) return String(n);
    var lang = (options && options.lang) || (isAr() ? 'ar' : 'en');
    if (lang !== 'ar' && f.en) return group(n) + ' ' + (n === 1 ? f.en[0] : f.en[1]);
    var hundred = f.hundred || genitive(f.many);
    if (n === 0) return f.zero || '0 ' + hundred;
    if (n === 1) return f.one;
    if (n === 2) return f.two;
    var r = n % 100;
    if (r >= 3 && r <= 10) return group(n) + ' ' + f.few;
    if (n >= 100 && r <= 2) return group(n) + ' ' + hundred;
    return group(n) + ' ' + f.many;
  }
  function digits(s) { return String(s == null ? '' : s).replace(/[\u0660-\u0669\u06F0-\u06F9]/g, function (d) { var c = d.charCodeAt(0); return String(c - (c >= 0x06F0 ? 0x06F0 : 0x0660)); }); }
  window.KlikAr = Object.assign(window.KlikAr || {}, { count: count, forms: FORMS, digits: digits, isAr: isAr });

  var T = isAr()
    ? { newTab: '(يفتح في نافذة جديدة)', bag: 'سلة التسوق', photos: 'صور المنتج', prevPhoto: 'الصورة السابقة', nextPhoto: 'الصورة التالية' }
    : { newTab: '(opens in a new tab)', bag: 'Shopping bag', photos: 'Product photos', prevPhoto: 'Previous photo', nextPhoto: 'Next photo' };
  var NEWTAB_RE = /new tab|new window|نافذة جديدة|تبويب جديد/i;

  /* ---------------- K-121: new-tab links ---------------- */
  // The note is an accessible description shared by every such link: nothing is added inside the links, so their
  // layout, :first-child / :last-child styles and accessible names stay exactly as their owners made them.
  var newTabNote = null;
  function noteId() {
    if (!newTabNote) {
      newTabNote = doc.getElementById('KlikA11yNewTab');
      if (!newTabNote) {
        newTabNote = doc.createElement('span');
        newTabNote.id = 'KlikA11yNewTab';
        // hidden: a description may point at hidden text, and nothing extra sits outside the page landmarks
        newTabNote.hidden = true;
        newTabNote.textContent = T.newTab;
        doc.body.appendChild(newTabNote);
      }
    }
    return newTabNote.id;
  }
  function markNewTab(a) {
    if (!a || a.closest('[data-klik-a11y-skip]')) return;
    var own = (a.getAttribute('aria-label') || '') + ' ' + (a.textContent || '') + ' ' + (a.getAttribute('title') || '');
    if (NEWTAB_RE.test(own)) return;
    var ids = (a.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    var id = noteId();
    if (ids.indexOf(id) >= 0) return;
    for (var i = 0; i < ids.length; i++) { var d = doc.getElementById(ids[i]); if (d && NEWTAB_RE.test(d.textContent || '')) return; }
    ids.push(id);
    a.setAttribute('aria-describedby', ids.join(' '));
  }
  function scanNewTab(scope) {
    var list = (scope || doc).querySelectorAll('a[target="_blank"]');
    for (var i = 0; i < list.length; i++) markNewTab(list[i]);
  }

  /* ---------------- K-121: bag count in the bag link's name, and a polite announcement ---------------- */
  var bagLast = null, bagNode = null, bagObserver = null, live = null;
  function bagPhrase(n) { return isAr() ? (n ? count(n, 'item') : 'فارغة') : (n ? n + (n === 1 ? ' item' : ' items') : 'empty'); }
  function announce(text) {
    if (!live) {
      live = doc.createElement('span');
      live.className = 'k-sr';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('data-klik-a11y-live', '');
      (doc.getElementById('MainContent') || doc.body).appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 60);
  }
  function bagUpdate() {
    var link = doc.querySelector('a.kt-cart-link');
    var num = link && link.querySelector('[data-kt-cart-count]');
    if (!num) return;
    if (num !== bagNode && window.MutationObserver) {
      if (bagObserver) bagObserver.disconnect();
      bagObserver = new MutationObserver(bagUpdate);
      bagObserver.observe(num, { childList: true, characterData: true, subtree: true });
      bagNode = num;
    }
    var n = parseInt(digits(num.textContent), 10);
    if (!isFinite(n) || n < 0) n = 0;
    // same wording as the server-rendered name in sections/klik-header.liquid (bugs-nav): "Shopping bag, 2 items"
    var base = link.getAttribute('data-kt-cart-label') || T.bag;
    var label = base + (isAr() ? '، ' : ', ') + bagPhrase(n);
    if (link.getAttribute('aria-label') !== label) link.setAttribute('aria-label', label);
    if (bagLast !== null && n !== bagLast && !link.querySelector('[aria-live]')) announce(label);
    bagLast = n;
  }
  ['cart:updated', 'cart:build', 'ajaxProduct:added', 'klik:cart-added'].forEach(function (ev) {
    doc.addEventListener(ev, function () { setTimeout(bagUpdate, 250); setTimeout(function () { scanNewTab(); }, 400); });
  });

  /* ---------------- K-052: thumbnails keep focus ---------------- */
  function patchSlideshow() {
    var S = window.theme && window.theme.Slideshow;
    var p = S && S.prototype;
    if (!p || typeof p.childNavGoTo !== 'function') return false;
    if (p.__klikA11y) return true;
    p.childNavGoTo = function (index) {
      var links = this.childNavLinks || [];
      for (var i = 0; i < links.length; i++) { links[i].classList.remove('is-active'); links[i].removeAttribute('aria-current'); }
      var el = links[index];
      if (!el) return;
      el.classList.add('is-active');
      el.setAttribute('aria-current', 'true');
      var sc = this.args && this.args.childNavScroller;
      if (!sc) return;
      if (this.args.childVertical) { sc.scrollTop = el.offsetTop - 100; return; }
      // same 100 px lead as Motion, measured from the start edge so it also works right to left
      var a = el.getBoundingClientRect(), b = sc.getBoundingClientRect();
      var rtl = getComputedStyle(sc).direction === 'rtl';
      sc.scrollLeft += rtl ? (a.right - b.right + 100) : (a.left - b.left - 100);
    };
    p.__klikA11y = true;
    return true;
  }

  /* ---------------- K-052: the lightbox runs in the page's direction ---------------- */
  // PhotoSwipe lays its photos out left to right, while the Arabic page gallery runs right to left (Flickity rightToLeft).
  // In Arabic the photos are handed to PhotoSwipe in reverse order, so the next photo sits on the left: the left arrow
  // button, the left arrow key and a swipe to the right all move to it, the photo slides in from the left, and the page
  // slideshow follows (the index sent back to Motion is mapped to page order). Motion is wrapped here, never edited.
  function rtl() { return isAr() || (root.getAttribute('dir') || '').toLowerCase() === 'rtl'; }
  function nameArrows(reversed) {
    var p = doc.querySelector('.pswp');
    if (!p) return;
    var l = p.querySelector('.pswp__button--arrow--left'), r = p.querySelector('.pswp__button--arrow--right');
    var lt = reversed ? T.nextPhoto : T.prevPhoto, rt = reversed ? T.prevPhoto : T.nextPhoto;
    if (l) { l.setAttribute('aria-label', lt); l.setAttribute('title', lt); }
    if (r) { r.setAttribute('aria-label', rt); r.setAttribute('title', rt); }
  }
  function patchPhotoswipe() {
    var P = window.theme && window.theme.Photoswipe && window.theme.Photoswipe.prototype;
    if (!P || typeof P.initGallery !== 'function' || typeof P.afterChange !== 'function') return false;
    if (P.__klikA11y) return true;
    var init = P.initGallery, after = P.afterChange;
    // index is 1-based (Motion opens at index - 1)
    P.initGallery = function (items, index) {
      var n = (items && items.length) || 0;
      if (!rtl() || n < 2) { this.__klikRev = 0; nameArrows(false); return init.call(this, items, index); }
      // a queued open comes back with the list it was given, already reversed
      if (items.__klikRev) { this.__klikRev = n; nameArrows(true); return init.call(this, items, index); }
      var pe = doc.querySelector('.pswp');
      if (pe && pe.klikPhotoswipeOwner === this && this.gallery && !this.closing) { this.gallery.goTo(n - index); return; }
      var rev = items.slice().reverse();
      rev.__klikRev = true;
      this.__klikRev = n;
      nameArrows(true);
      return init.call(this, rev, n - index + 1);
    };
    P.afterChange = function () {
      var n = this.__klikRev;
      if (!n || !this.gallery) return after.apply(this, arguments);
      this.container.dispatchEvent(new CustomEvent('photoswipe:afterChange', { detail: { index: n - 1 - this.gallery.getCurrentIndex() } }));
    };
    P.__klikA11y = true;
    return true;
  }

  /* ---------------- K-052 / K-136: the lightbox as a modal dialog ---------------- */
  var pswpOpener = null;
  function rememberOpener(e) {
    var t = e.target && e.target.closest && e.target.closest('.js-photoswipe__zoom,[data-photoswipe-src],a,button,[tabindex]');
    if (t && !t.closest('.pswp')) pswpOpener = t;
  }
  function productName() {
    var h = doc.querySelector('#MainContent h1') || doc.querySelector('h1');
    var t = h ? (h.textContent || '').replace(/\s+/g, ' ').trim() : '';
    return t.length > 90 ? t.slice(0, 88) + '…' : t;
  }
  function focusables(box) {
    var list = box.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])');
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var el = list[i], r = el.getBoundingClientRect(), s = getComputedStyle(el);
      if (r.width > 0 && r.height > 0 && s.visibility !== 'hidden' && s.display !== 'none' && !el.disabled) out.push(el);
    }
    return out;
  }
  function initLightbox() {
    var p = doc.querySelector('.pswp');
    if (!p || p.__klikA11y) return;
    p.__klikA11y = true;
    var open = false, opener = null;
    function onOpen() {
      open = true;
      opener = pswpOpener && pswpOpener.isConnected ? pswpOpener : (doc.activeElement !== doc.body && !p.contains(doc.activeElement) ? doc.activeElement : null);
      var name = productName();
      p.setAttribute('aria-label', name ? T.photos + (isAr() ? ': ' : ': ') + name : T.photos);
      p.setAttribute('aria-modal', 'true');
      p.setAttribute('aria-hidden', 'false');
      setTimeout(function () { if (open && !p.contains(doc.activeElement)) p.focus({ preventScroll: true }); }, 30);
    }
    var pending = null, pendingUntil = 0;
    // a control that can hold focus where it is: on screen, not hidden, not inside a hidden slide
    function canHold(el) {
      if (!el || !el.isConnected || p.contains(el)) return false;
      var r = el.getBoundingClientRect();
      if (r.width < 1 || r.height < 1) return false;
      var s = getComputedStyle(el);
      return s.visibility !== 'hidden' && s.display !== 'none' && !el.closest('[aria-hidden="true"],[inert]');
    }
    // where focus goes back to: the opener while its photo is still the one shown; after browsing, Motion has moved the
    // slideshow to the photo last shown and the opener sits in a hidden slide, so the zoom button of the shown photo
    // takes it, else the slideshow itself (tabindex 0)
    function landing(o) {
      var cell = o && o.closest && o.closest('.product-main-slide,.flickity-cell');
      if (canHold(o) && (!cell || cell.classList.contains('is-selected'))) return o;
      var show = o && o.closest ? o.closest('.flickity-enabled,.product-slideshow') : doc.querySelector('.product-slideshow.flickity-enabled');
      var scope = show || (o && o.closest && o.closest('[data-section-id],.shopify-section')) || doc;
      var sels = ['.is-selected .js-photoswipe__zoom', '.js-photoswipe__zoom'];
      for (var k = 0; k < sels.length; k++) {
        var zooms = scope.querySelectorAll(sels[k]);
        for (var i = 0; i < zooms.length; i++) if (canHold(zooms[i])) return zooms[i];
      }
      if (show && canHold(show)) return show;
      return canHold(o) ? o : null;
    }
    // Motion hides the page while the lightbox is open on iPhone (pswp-open-in-ios), and moves the slideshow when the
    // lightbox closes: keep checking for 3 s, and never leave focus on <body> in that time, unless the person has moved
    // focus somewhere useful themselves
    function returnFocus() {
      if (!pending) return;
      if (Date.now() > pendingUntil) { pending = null; return; }
      var a = doc.activeElement;
      var t = landing(pending);
      // focus the person moved on purpose (not Motion's move to the opener, which may sit in a hidden slide) stays
      if (a && a !== doc.body && a !== root && a !== pending && a !== t && !p.contains(a) && canHold(a)) { pending = null; return; }
      if (t && a !== t) { try { t.focus({ preventScroll: true }); } catch (e) {} }
    }
    function onClose() {
      open = false;
      p.removeAttribute('aria-modal');
      p.setAttribute('aria-hidden', 'true');
      pending = opener;
      pendingUntil = Date.now() + 3000;
      returnFocus();
      [60, 250, 700, 1400, 2200, 3000].forEach(function (ms) { setTimeout(returnFocus, ms); });
    }
    // a click elsewhere on the page after closing is the person's own choice of focus
    doc.addEventListener('pointerdown', function (e) { if (pending && !p.contains(e.target)) pending = null; }, true);
    function sync() {
      var isOpen = p.classList.contains('pswp--open') && !p.classList.contains('pswp--klik-closing');
      if (isOpen && !open) onOpen(); else if (!isOpen && open) onClose(); else if (!isOpen) returnFocus();
    }
    if (window.MutationObserver) new MutationObserver(sync).observe(p, { attributes: true, attributeFilter: ['class'] });
    p.addEventListener('keydown', function (e) {
      if (!open || e.key !== 'Tab') return;
      var f = focusables(p);
      if (!f.length) { e.preventDefault(); p.focus({ preventScroll: true }); return; }
      var first = f[0], last = f[f.length - 1], a = doc.activeElement;
      if (e.shiftKey && (a === first || a === p || !p.contains(a))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (a === last || !p.contains(a))) { e.preventDefault(); first.focus(); }
    });
    // focus that leaves the open lightbox by any other route comes back to it
    doc.addEventListener('focusin', function (e) {
      if (!open || p.contains(e.target)) return;
      // Motion's close handler moves focus to the opener before the class change reaches the observer: let it go
      if (!p.classList.contains('pswp--open') || p.classList.contains('pswp--klik-closing')) { sync(); return; }
      var f = focusables(p); (f[0] || p).focus({ preventScroll: true });
    });
  }

  /* ---------------- start ---------------- */
  doc.addEventListener('pointerdown', rememberOpener, true);
  doc.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') rememberOpener(e); }, true);
  doc.addEventListener('focusin', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[target="_blank"]');
    if (a) markNewTab(a);
  });
  function start() {
    scanNewTab();
    bagUpdate();
    initLightbox();
    var a = patchSlideshow(), b = patchPhotoswipe();
    if (!a || !b) {
      // theme.js is deferred (and lazy on the home page): try again while it arrives, then stop
      var tries = 0;
      var t = setInterval(function () { a = a || patchSlideshow(); b = b || patchPhotoswipe(); if ((a && b) || ++tries > 20) clearInterval(t); }, 500);
    }
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  window.addEventListener('load', function () {
    scanNewTab(); bagUpdate(); patchSlideshow(); patchPhotoswipe();
    // product pages build their help and route links after load: two late passes instead of a page-wide observer
    setTimeout(scanNewTab, 1500);
    setTimeout(scanNewTab, 5000);
  }, { once: true });
}());
